import { render, staticRenderFns } from "./albumLife.vue?vue&type=template&id=3d9b28b5&scoped=true"
import script from "./albumLife.vue?vue&type=script&lang=js"
export * from "./albumLife.vue?vue&type=script&lang=js"
import style0 from "./albumLife.vue?vue&type=style&index=0&id=3d9b28b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b28b5",
  null
  
)

export default component.exports